import type { Route } from '@angular/router';

export const routes: Route[] = [
  {
    path: 'login',
    loadComponent: () =>
      import('@szte-griffin/core/auth/ui').then(({ LoginComponent }) => LoginComponent),
  },
];

export default routes;
